/**
 * A generous bounding box covering all five boroughs (plus a small margin). Used
 * to decide whether a coordinate is "in NYC" — for auto-centering the map and for
 * filtering feeds whose upstream covers a wider territory than the city (e.g. the
 * ConEd outage feed, which also serves Westchester).
 */
export const NYC_BOUNDS = {
    minLng: -74.3,
    maxLng: -73.68,
    minLat: 40.47,
    maxLat: 40.93,
};
/** True when a [lng, lat] coordinate falls inside the NYC bounding box. */
export function isInNyc([lng, lat]) {
    return (lng >= NYC_BOUNDS.minLng &&
        lng <= NYC_BOUNDS.maxLng &&
        lat >= NYC_BOUNDS.minLat &&
        lat <= NYC_BOUNDS.maxLat);
}
